import {
  GET_GOOGLE_RECAPTCHA_TOKEN,
  GET_GOOGLE_RECAPTCHA_TOKEN_ERROR,
  GET_GOOGLE_RECAPTCHA_TOKEN_SUCCESS,
  VERIFY_GOOGLE_RECAPTCHA_TOKEN,
  VERIFY_GOOGLE_RECAPTCHA_TOKEN_ERROR,
  VERIFY_GOOGLE_RECAPTCHA_TOKEN_SUCCESS
} from './recaptcha.actions'

const recaptchaState = {
  error: undefined,
  gettingToken: false,
  hostName: '',
  score: '',
  verifyingToken: false,
  token: undefined
}

/**
 * The Recaptcha's reducer.
 */
const recaptchaReducer = (state = recaptchaState, { payload, type }) => {
  switch (type) {
    case GET_GOOGLE_RECAPTCHA_TOKEN: {
      return { ...state, gettingToken: true, error: undefined }
    }
    case GET_GOOGLE_RECAPTCHA_TOKEN_SUCCESS: {
      return {
        ...state,
        gettingToken: false,
        error: undefined,
        hostName: '',
        score: '',
        token: payload.token
      }
    }
    case GET_GOOGLE_RECAPTCHA_TOKEN_ERROR: {
      return {
        ...state,
        gettingToken: false,
        error: payload.error
      }
    }
    case VERIFY_GOOGLE_RECAPTCHA_TOKEN: {
      return {
        ...state,
        error: undefined,
        hostName: '',
        score: '',
        verifyingToken: true
      }
    }
    case VERIFY_GOOGLE_RECAPTCHA_TOKEN_SUCCESS: {
      return {
        ...state,
        verifyingToken: false,
        hostName: payload.hostName,
        score: payload.score,
        error: undefined
      }
    }
    case VERIFY_GOOGLE_RECAPTCHA_TOKEN_ERROR: {
      return {
        ...state,
        verifyingToken: false,
        error: payload.error
      }
    }
    default: {
      return state
    }
  }
}

export default recaptchaReducer
